var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "resources"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(0), _c('hr'), _c('div', {
    staticClass: "resource_container"
  }, [_vm._m(1), _c('div', {
    staticClass: "resource"
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/resources_view/Group.png")
    }
  }), _c('h3', [_vm._v("Learning Resources")]), _c('p', [_vm._v("Learn more about blockchain basics")]), _c('div', {
    staticClass: "buts"
  }, [_c('router-link', {
    attrs: {
      "to": "/comingsoon?network=".concat(_vm.DEFAULT_NETWORK_NAME)
    }
  }, [_vm._v("Documentation")]), _c('a', {
    attrs: {
      "href": "/comingsoon?network=".concat(_vm.DEFAULT_NETWORK_NAME),
      "target": "_blank"
    }
  }, [_vm._v("Github")])], 1)])])])]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "header"
  }, [_c('h2', [_vm._v("Dcomm Directory")])]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "resource"
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/resources_view/Wallet.png")
    }
  }), _c('h3', [_vm._v("Wallet & Faucet")]), _c('p', [_vm._v("Used to receive and spend cryptoassets")]), _c('div', {
    staticClass: "buts"
  }, [_c('a', {
    attrs: {
      "href": "https://wallet.dcomm.community",
      "target": "_blank"
    }
  }, [_vm._v("Wallet")]), _c('a', {
    attrs: {
      "href": "https://faucet.dcomm.network/",
      "target": "_blank"
    }
  }, [_vm._v("Faucet")])])]);
}]

export { render, staticRenderFns }